import * as React from 'react';

import Title from '../../../containers/Editor/Title';
import ButtonBack from '../../../containers/Editor/ButtonBack';
import ButtonRemovePage from '../../../containers/Editor/ButtonRemovePage';
import ButtonDuplicatePage from '../../../containers/Editor/ButtonDuplicatePage';
import ButtonPageSelection from '../../../containers/Editor/ButtonPageSelection';
import ButtonPreview from '../../../containers/Editor/ButtonPreview';
import ButtonEdit from '../../../containers/Editor/ButtonEdit';
import ButtonSend from '../../../containers/Editor/ButtonSend';
import ButtonZoom from '../../../containers/Editor/ButtonZoom';
import { StyledHeader } from './styles';

interface HeaderProps {
	isEditorLoaded: boolean;
	isButtonEditDisplayed: boolean;
	isButtonRemoveDisplayed: boolean;
	isButtonPageSelectionDisplayed: boolean;
	isButtonDuplicateDisplayed: boolean;
}

const Header = ({
	isEditorLoaded,
	isButtonRemoveDisplayed,
	isButtonEditDisplayed,
	isButtonPageSelectionDisplayed,
	isButtonDuplicateDisplayed,
}: HeaderProps) => (
	<StyledHeader>
		<ButtonBack />
		{isEditorLoaded &&
			<>
				<Title />
				<ButtonZoom />
				{isButtonPageSelectionDisplayed && <ButtonPageSelection />}
				{isButtonRemoveDisplayed && <ButtonRemovePage />}
				{isButtonDuplicateDisplayed && <ButtonDuplicatePage />}
				<ButtonPreview />
				{isButtonEditDisplayed && <ButtonEdit />}
				<ButtonSend />
			</>
		}
	</StyledHeader>
);

export default Header;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Header/index.tsx